import { render, staticRenderFns } from "./ConsentFull.vue?vue&type=template&id=3e2c950f&"
import script from "./ConsentFull.vue?vue&type=script&lang=js&"
export * from "./ConsentFull.vue?vue&type=script&lang=js&"
import style0 from "./ConsentFull.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports